<template>
    <div id="players-container" class="players-container">
        <!--        <div class="header-bg"></div>-->
        <div class="table-inner">
            <table class="users-playing table-sm table-striped">
                <thead>
                <tr>
                    <th><div class=""><span>USER</span></div></th>
                    <th><div class="text-right"><span>@</span></div></th>
                    <th><div class="text-right"><span>BET</span></div></th>
                    <th><div class="text-right"><span>PROFIT</span></div></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="player in this.tr_players" :class="player.classname">
                    <td><a href="javascript:void(0)" class="lbl-betting" @click="doOpenUser(player.user_id)">{{utils.maskedUsername(player.username, state.display_masked_username)}}</a>
                    <td class="text-right"><span class="lbl-betting">{{player.stopped_at ? Clib.formatSatoshis(player.stopped_at / 100) +'x' : '-'}}</span></td>
                    <td class="text-right"><span class="lbl-betting">{{player.bet ? utils.comma(player.bet) : '?'}} </span></td>
                    <td class="text-right"><span class="lbl-betting">{{player.profit ? utils.comma(player.profit) : '-'}} </span></td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>

    const CX = require('classnames').default;

    export default {
        name: "player-container",
        props: ['state'],
        data: function()
        {
            return {
                Clib: Clib,
                utils: utils,
                player_limit: 30,
                users_won_cashed: null,
                users_lost_playing: null,
                tr_users_won_cashed: null,
                tr_users_lost_playing: null,
                tr_players: [],
            };
        },
        created()
        {
            EventBus.$on('connected', this.onChange);
            EventBus.$on('game_starting', this.onChange);
            EventBus.$on('game_started', this.onChange);
            EventBus.$on('game_crash', this.onChange);
            EventBus.$on('player_bet', this.onChange);
            EventBus.$on('cashed_out', this.onChange);
        },
        beforeDestroy()
        {
            EventBus.$off('connected', this.onChange);
            EventBus.$off('game_starting', this.onChange);
            EventBus.$off('game_started', this.onChange);
            EventBus.$off('game_crash', this.onChange);
            EventBus.$off('player_bet', this.onChange);
            EventBus.$off('cashed_out', this.onChange);
        },
        mounted()
        {
            EventBus.$emit('push_component', 'player-container');
            this.render();
        },
        beforeUpdate()
        {
            // console.log('player-container before update');
        },
        updated()
        {
            // console.log('player-container update');
        },
        methods: {
            onChange()
            {
                this.render();
            },
            render()
            {
                let self = this;

                this.users_won_cashed = [];
                this.users_lost_playing = [];

                this.tr_users_won_cashed = [];
                this.tr_users_lost_playing = [];

                /**
                 * Separate and sort the users depending on the game state
                 */
                if (this.state.game_state === 'STARTING') {
                    // The list is already ordered by engine given an index
                    let joined = this.state.joined;
                    for (let i = 0; i < joined.length; i++) {
                        let player = joined[i];
                        let bet; // can be undefined
                        if (player.user_id === self.state.user_id) {
                            bet = self.state.current_bet_amount;
                            this.users_lost_playing.unshift({user_id: player.user_id, bet: bet, username: player.username});
                        } else {
                            this.users_lost_playing.push({user_id: player.user_id, bet: bet, username: player.username});
                        }
                    }

                    this.users_lost_playing = _.take(this.users_lost_playing, this.player_limit);

                } else {

                    let won_me = null;
                    let lost_me = null;

                    _.forEach(this.state.player_info, function (player, user_id) {
                        if (player.stopped_at) {
                            if (user_id == self.state.user_id) {
                                won_me = player;
                            } else {
                                self.users_won_cashed.push(player);
                            }
                        } else {
                            if (user_id == self.state.user_id) {
                                lost_me = player;
                            } else {
                                self.users_lost_playing.push(player);
                            }
                        }
                    });

                    if (won_me) {
                        this.users_won_cashed.push(won_me);
                    }
                    if (lost_me) {
                        if (this.users_won_cashed.length >= this.player_limit) {
                            this.users_won_cashed = _.takeRight(this.users_won_cashed, this.player_limit - 1);
                        }
                        this.users_lost_playing.unshift(lost_me);
                    }

                    this.users_won_cashed = _.takeRight(this.users_won_cashed, this.player_limit);
                    this.users_lost_playing = _.take(this.users_lost_playing, this.player_limit - this.users_won_cashed.length);

                    this.users_lost_playing.sort(function(a, b) {
                        let r = b.bet - a.bet;
                        if (r !== 0) return r;
                        return a.username < b.username ? 1 : -1;
                    });

                    this.users_won_cashed.sort(function(a, b) {
                        let r = b.stopped_at - a.stopped_at;
                        if (r !== 0) return r;
                        return a.username < b.username ? 1 : -1;
                    });
                }

                /**
                 * Create the rows for the table
                 */
                // Users Playing and users cashed
                if (this.state.game_state === 'IN_PROGRESS' || this.state.game_state === 'STARTING') {

                    let i, length;

                    for (i = 0, length = this.users_lost_playing.length; i < length; i++) {

                        let user = this.users_lost_playing[i];
                        let classes = CX({
                            'user-playing': true,
                            'me': this.state.user_id == user.user_id
                        });
                        user.classname = classes;

                        this.tr_users_lost_playing.push(user);
                    }

                    for (i = 0, length = this.users_won_cashed.length; i < length; i++) {

                        let user = this.users_won_cashed[i];
                        let profit = this.calcProfit(user.bet, user.stopped_at);
                        let classes = CX({
                            'user-cashed': true,
                            'me': this.state.user_id == user.user_id
                        });
                        user.classname = classes;
                        user.profit = profit;

                        this.tr_users_won_cashed.push(user);
                    }

                } else if (this.state.game_state == 'ENDED') {

                    let i, length;

                    for (i = 0, length = this.users_lost_playing.length; i < length; i++) {

                        let user = this.users_lost_playing[i];
                        let bet = user.bet;
                        let profit = -bet;

                        let classes = CX({
                            'user-lost': true,
                            'me': self.state.user_id == user.user_id
                        });

                        user.classname = classes;
                        user.profit = profit;

                        this.tr_users_lost_playing.push(user);
                    }

                    for (i = 0, length = this.users_won_cashed.length; i < length; i++) {

                        let user = this.users_won_cashed[i];
                        let bet = user.bet;
                        let profit = bet * (user.stopped_at - 100) / 100;


                        let classes = CX({
                            'user-won': true,
                            'me': self.state.user_id == user.user_id
                        });

                        user.classname = classes;
                        user.profit = profit;

                        this.tr_users_won_cashed.push(user);
                    }
                }

                // this.tr_users_won_cashed.reverse();

                this.tr_players = _.union(this.tr_users_lost_playing, this.tr_users_won_cashed);
                this.tr_players = this.tr_players;
            },
            calcProfit(bet, stopped_at)
            {
                return ((stopped_at - 100) * bet) / 100;
            },
            doOpenUser(user_id)
            {
                this.state.modals.user_stats.display = true;
                this.state.modals.user_stats.data.user_id = user_id;
            },
        }
    }
</script>

<style scoped>

</style>
